import { queryOptions } from '@tanstack/react-query';

import type { components } from '@/generated/bff';
import { bff, unwrap } from '@/lib/api/bff';

export type ApiKey = components['schemas']['ApiKey'];
export type KeyWithSecret = components['schemas']['KeyWithSecret'];
export type ScopeOption = components['schemas']['ScopeOption'];
export type Environment = ApiKey['environment'];

/** Matches PortalKeysController::MAX_KEYS_PER_ENVIRONMENT. */
export const MAX_ACTIVE_KEYS = 5;

export const keysQuery = queryOptions({
    queryKey: ['portal', 'keys'],
    queryFn: async () => (await unwrap(bff.GET('/portal/keys'))).data,
});

export const scopesQuery = queryOptions({
    queryKey: ['portal', 'scopes'],
    queryFn: async () => (await unwrap(bff.GET('/portal/scopes'))).data,
    staleTime: 5 * 60_000,
});

export const ENVIRONMENT_LABEL: Record<Environment, string> = { test: 'Sandbox', live: 'Live' };
